import React, { useContext, useState, useEffect } from 'react';
import { recordImpressionByName } from '@JohnLewisPartnership/experiments-utils';
import PropTypes from 'prop-types';
import { EnvVarsFeaturesContext } from '../../scaffold/EnvVarsFeaturesContext';
import { DesktopMenu } from './desktop-menu/DesktopMenu';
import { getNavigation } from '../../../client/fetch/get-navigation';
import {
  addMediaQueryListener,
  isTabletPortrait,
} from '../../utils/device/identifyDevice';
import { SEOLinks } from './seo-links/SEOLinks';
import { isMonetateGroup } from '../../utils/monetate/isMonetateGroup';
import { MobileMenu } from './mobile-menu/MobileMenu';

export const fetchChildCategories =
  (queryParams, subset) =>
  ({ id }) =>
    getNavigation({ id, depth: 4, subset, queryParams });

export const Navigation = ({ mobileNavShown }) => {
  const {
    categories,
    envVars: { monetate },
    features: { monetateExperiences, displaySEOLinks },
    headerClientConfigQueryParameters,
    columnHighlighted: isColumnHighlightedActive,
    mobileBoostWishlist: isMobileFooterWishlistActive,
  } = useContext(EnvVarsFeaturesContext);
  const [flyoutCategories, setFlyoutCategories] = useState({});

  const isTabbedNavActive = isMonetateGroup(
    { monetateExperiences },
    'tabbed-nav-design'
  );

  const menus = [
    {
      id: 'shop-by-department',
      name: 'Shop by department',
      child: categories.child,
    },
  ];

  const subset = `MOBILE_WEB${
    typeof window !== 'undefined' &&
    window?.__PRELOADED_STATE__?.mobileWebExperiment === true
      ? '_EXPERIMENT'
      : ''
  },FLYOUT`;

  const fetch = fetchChildCategories(headerClientConfigQueryParameters, subset);

  const fetchFlyoutCategories = async () => {
    const navCategories = await getNavigation({
      subset: 'MOBILE_WEB,FLYOUT',
      queryParams: headerClientConfigQueryParameters,
    });
    setFlyoutCategories(navCategories);
  };

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      isTabletPortrait() &&
      !flyoutCategories?.child
    ) {
      addMediaQueryListener(fetchFlyoutCategories);
    }
  }, []);

  useEffect(() => {
    if (mobileNavShown) {
      recordImpressionByName(
        monetate.channel,
        monetateExperiences,
        'mobile-menu-open'
      );
    }
  }, [mobileNavShown]);

  if (mobileNavShown) {
    return (
      <MobileMenu
        menus={menus}
        fetchChildCategories={fetch}
        isMobileFooterWishlistActive={isMobileFooterWishlistActive}
      />
    );
  }

  return (
    <>
      <DesktopMenu
        isTabbedNavActive={isTabbedNavActive}
        isColumnHighlightedActive={isColumnHighlightedActive}
        child={
          flyoutCategories.child ? flyoutCategories.child : categories.child
        }
      />
      {displaySEOLinks && <SEOLinks categories={categories.child} />}
    </>
  );
};

Navigation.propTypes = {
  mobileNavShown: PropTypes.bool.isRequired,
};
